import { JobHoverData } from "@repo/common"
import { createContext, useContext } from "react"

/**
 * Fetches a single job's hover data (actions / booked items) on demand.
 *
 * Injected via context so the shared UniversalJobCard never imports the CRM
 * api/query layer directly — that keeps the component renderable in Storybook
 * (and type-checkable by the docs project), where no fetcher is provided and
 * the card simply shows the non-lazy parts of the hover tooltip.
 */
export type JobHoverDataFetcher = (
  jobId: string,
) => Promise<JobHoverData | null>

const JobHoverDataFetcherContext = createContext<JobHoverDataFetcher | null>(
  null,
)

export const JobHoverDataFetcherProvider = JobHoverDataFetcherContext.Provider

export function useJobHoverDataFetcher(): JobHoverDataFetcher | null {
  return useContext(JobHoverDataFetcherContext)
}
